import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';

export const megaMenu = () => {
  Alpine.data('megaMenu', () => ({
    megaMenuWrapper: null,
    megaMenuHamburger: null,
    closeSubMenus() {
      const dropdownParents = document.querySelectorAll('.tbm-item--has-dropdown');
      dropdownParents.forEach((dropdownParent) => {
        dropdownParent.classList.remove('open');
      });
    },
    handleOutsideClick(event) {
      if (!this.megaMenuWrapper) {
        return;
      }

      if (!this.megaMenuWrapper.contains(event.target)) {
        this.megaMenuWrapper.classList.remove('tbm--mobile-show');
        this.megaMenuHamburger.removeAttribute('aria-expanded');
        this.pageOverlay.classList.add('hidden');
        this.closeSubMenus();
      }
    },
    backLinks() {
      const backLinkItems = document.querySelectorAll(
        '.o-dropdown-menu__submenu--back-link.level-1 button'
      );
      backLinkItems.forEach((backLink) => {
        backLink.addEventListener('click', () => {
          this.closeSubMenus();
          const backLinkParentLink = backLink.closest('.tbm-submenu');
          backLinkParentLink.classList.remove('slide');
        });
      });
    },
    bindMegaMenu: {
      // eslint-disable-next-line func-names
      '@load.window': function () {
        this.megaMenuWrapper = document.querySelector('nav.tbm.tbm-main');
        this.megaMenuHamburger = document.querySelector('.m-menu__menu-toggle');
        this.pageOverlay = document.querySelector('.site-menu-background');
        this.megaMenuHamburger.addEventListener('click', () => {
          this.closeSubMenus();
          this.megaMenuHamburger.toggleAttribute('aria-expanded');
          this.megaMenuWrapper.classList.toggle('tbm--mobile-show');
          if (this.megaMenuWrapper.classList.contains('tbm--mobile-show')) {
            this.pageOverlay.classList.add('hidden');
            document.querySelector('body').classList.add('overflow-hidden');
          } else {
            this.pageOverlay.classList.remove('hidden');
            document.querySelector('body').classList.remove('overflow-hidden');
          }
        });
        const links = document.querySelectorAll('.tbm .level-1.tbm-toggle');
        links.forEach((link) => {
          link.addEventListener('click', () => {
            if (!this.megaMenuWrapper.classList.contains('tbm--mobile')) {
              const liElement = link.closest('li.tbm-item');
              if (!liElement.classList.contains('open')) {
                this.pageOverlay.classList.remove('hidden');
              } else {
                this.pageOverlay.classList.add('hidden');
              }
            }
          });
        });
        this.backLinks();
        this.closeSubMenus();
      },
      // eslint-disable-next-line func-names
      '@click.outside': function (event) {
        this.handleOutsideClick(event);
      },
    },
  }));
};
